<template>
  <div>
    <div style="width: 100%;" class="div-inline">
      <el-form :model="selectForm" label-width="80px" ref="selectForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label="线路" prop="BusLinesId">
            <el-select @change="selectChanged" v-model="selectForm.BusLinesId" placeholder="请选择线路">
              <el-option
                v-for="item in busLiness"
                :key="item.Id"
                :value="item.BaiduMapLineName"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-button type="primary" @click.native="updateSiteData" style="float:right;">更新站点数据到数据库</el-button>
        </el-row>
      </el-form>
      <template>
        <baidu-map @ready="handlerMap" >
          <bm-view class="map">
          </bm-view>
          <div style="width:20%; background: #f3f1ec; overflow: hidden;">          
              <bm-bus :keyword="selectForm.BusLinesId" :auto-viewport="true" @getbuslistcomplete="onGetbuslistcomplete" @buslinehtmlset="onBusLineHtmlSet" location="五指山"></bm-bus>
          </div>
        </baidu-map>
      </template>
    </div>
    <div class="div-inline" style="padding-left:10px;">
      <div id="LineName_0" >
      </div>
      <div id="Container_0" >
      </div>
      <div id="LineName_1" >
      </div>
      <div id="Container_1" >
      </div>
    </div>
  </div>
</template>

<script>
import { BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker, BmNavigation} from 'vue-baidu-map'
import { getBusLinesListPage, batchAddSiteData, baiduTrans } from "../../api/api";
export default {
  components: {
      BaiduMap,
      BmControl,
      BmView,
      BmAutoComplete,
      BmLocalSearch,
      BmMarker,
      BmNavigation,
    },
    data: function(){
      return {
        tempVar:null,
        busLiness: [], //线路列表
        // siteDatas: [], //站点数据
        forwardLineSiteData: {}, //正向站点数据
        reverseLineSiteData: {}, //反向站点数据
        siteJsonObj: {}, //站点数据
        busLinesId: "",
        viaBusLine: "",
        selectForm: {
          BusLinesId: "" //
        }
      }
    },
    methods: {
      async handlerMap ({BMap, map}) {
        // this.BMap = BMap
        // this.map = map
        // let _this = this
      },
      selectChanged(value) {
        this.setbusLinesId(value);
        this.siteJsonObj = {};
        this.forwardLineSiteData = {};
        this.reverseLineSiteData = {};
        var lineName_0 = document.getElementById("LineName_0"); 
        var lineName_1 = document.getElementById("LineName_1"); 
        var container_0 = document.getElementById("Container_0"); 
        var container_1 = document.getElementById("Container_1"); 
        lineName_0.innerHTML ="";
        lineName_1.innerHTML ="";
        container_0.innerHTML ="";
        container_1.innerHTML ="";
      },
      setbusLinesId(value){
        let obj = this.busLiness.find((item)=>{
          return item.BaiduMapLineName === value;
        });
        
        this.busLinesId = obj.Id;
        this.viaBusLine = obj.LineChineseName;
      },
      onGetbuslistcomplete:function(result)
      {
        this.tempVar = result;
      },
      onBusLineHtmlSet : function(){ 
        if(this.tempVar)
        {
          try{
            this.getContainer(this.tempVar, this.viaBusLine); 
          }catch(e){ 

          }
        }
      },
      getContainer(result,viaBusLine){ 
        this.forwardLine(result['0'],viaBusLine);
        this.reverseLine(result['1'],viaBusLine);
      },
      forwardLine(data,viaBusLine){ 
        var lineName = document.getElementById("LineName_0");
        var container = document.getElementById("Container_0"); 
        var stations = [];
        var html = []; 
        if(data && data !== undefined)
        {
          stations = data.gC; 
          if(stations === undefined)
          {
            stations = data.VB; 
          }

          if(stations === undefined)
          {
            stations = data.UB; 
          }

          if (stations === undefined) {
            stations = data.TB;
          }

          if(stations.length > 0){
            this.forwardLineSiteData = {};
            let siteStations = [];
            lineName.innerHTML = data.name; 
            let i=0;
            stations.forEach(function(item){ 
              i++;
              siteStations.push({
                SiteNumber:i,
                BusLineDirectionChineseName:data.name,
                ViaBusLine:viaBusLine,
                SiteChineseName:item.name,
                Longitude:item.position.lng,
                Latitude:item.position.lat
              })
              html.push('<li>' + item.name + ' ' + item.position.lng + ' ' + item.position.lat + '</li>'); 
            });
            container.innerHTML = '<ul>' + html.join('') + '</ul>'; 
            this.forwardLineSiteData.SiteDatas = siteStations;
          }
        }
      },
      reverseLine(data,viaBusLine){ 
        var lineName = document.getElementById("LineName_1");
        var container = document.getElementById("Container_1"); 
        var stations = [];
        var html = []; 
        if(data && data !== undefined)
        {
          stations = data.gC; 
          if(stations === undefined)
          {
            stations = data.VB; 
          }

          if(stations === undefined)
          {
            stations = data.UB; 
          }

          if (stations === undefined) {
            stations = data.TB;
          }

          if(stations.length > 0){
            this.reverseLineSiteData = {};
            let siteStations = [];
            lineName.innerHTML = data.name; 
            let j=0;
            stations.forEach(function(item){ 
              j++;
              siteStations.push({
                SiteNumber:j,
                BusLineDirectionChineseName:data.name,
                ViaBusLine:viaBusLine,
                SiteChineseName:item.name,
                Longitude:item.position.lng,
                Latitude:item.position.lat
              })
              html.push('<li>' + item.name + ' ' + item.position.lng + ' ' + item.position.lat + '</li>'); 
            });
            container.innerHTML = '<ul>' + html.join('') + '</ul>';
            this.reverseLineSiteData.SiteDatas = siteStations;
          }
        }
      },
      updateSiteData(){
        let container_0 = document.getElementById("Container_0"); 
        let container_1 = document.getElementById("Container_1");
        if(container_0.innerText ==="" && container_1.innerText ==="")
        {
          this.$message({
            message: "没有更新数据",
            type: "error"
          });
        } else {
          this.siteJsonObj={};
          let SiteDatas = [];
          
          if(this.forwardLineSiteData.SiteDatas !== undefined)
          {
            this.forwardLineSiteData.SiteDatas.forEach(function(item){ 
              SiteDatas.push({
                SiteNumber:item.SiteNumber,
                BusLineDirectionChineseName:item.BusLineDirectionChineseName,
                ViaBusLine:item.ViaBusLine,
                SiteChineseName:item.SiteChineseName,
                Longitude:item.Longitude,
                Latitude:item.Latitude
              })
            })
          }
          
          if(this.reverseLineSiteData.SiteDatas !== undefined)
          {
            this.reverseLineSiteData.SiteDatas.forEach(function(item){ 
              SiteDatas.push({
                SiteNumber:item.SiteNumber,
                BusLineDirectionChineseName:item.BusLineDirectionChineseName,
                ViaBusLine:item.ViaBusLine,
                SiteChineseName:item.SiteChineseName,
                Longitude:item.Longitude,
                Latitude:item.Latitude
              })
            })
          }

          // let k=0;
          // SiteDatas.forEach(function(item){ 
          //   k++;
          //   (function (k) {
          //     setTimeout(function () {
          //       let para = {q: item.name };
          //       baiduTrans(para).then(res => {
          //         item.SiteEnglishName = res.data.response;
          //       }); 
          //     }, 115 * k);
          //   })(k);
          // });

          this.siteJsonObj.BusLinesId = this.busLinesId;
          this.siteJsonObj.SiteDatas=SiteDatas;

          batchAddSiteData(this.siteJsonObj).then(res => {
          if (res.data.success) {
            this.addLoading = false;
            this.$message({
              message: res.data.msg,
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
        }
      }
    },
    mounted() {
      let pageSizePara = {
        pageSize: 100
      };
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLiness = res.data.response.data;
        this.selectForm.BusLinesId = this.busLiness.length > 0 ? this.busLiness[0].BaiduMapLineName : "";
        this.setbusLinesId(this.selectForm.BusLinesId);
      });
  }
}
</script>

<style scoped>
  .map{
    width:80%;
    height:500px;  float: right;}
  
  .div-inline{ 
    display:inline;
    float:left;
  } 
  
  </style>

